module.exports = InternalShared('InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options');